/**
 * ConflictBanner — aviso de conflito de concorrência (HTTP 409, RN-M8-004,
 * US-08 §6). Exibe que a visita foi alterada por outro usuário e oferece
 * "Recarregar" para trazer o estado atual antes de reeditar.
 */

export function ConflictBanner({ onRecarregar }: { onRecarregar: () => void }): JSX.Element {
  return (
    <div className="conflict-banner" role="alert">
      <span>
        Esta visita foi alterada por outro usuário desde que você abriu a ficha. Recarregue para
        ver o estado atual antes de salvar de novo.
      </span>
      <button type="button" className="btn btn-primary" onClick={onRecarregar}>
        Recarregar
      </button>
    </div>
  );
}
